import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OptimizeImagesService from 'services/OptimizeImages.service';

import styles from './EmployeeTile.module.scss';

import { Bind } from 'lodash-decorators/bind';

class EmployeeTile extends Component {
  static propTypes = {
    photo: PropTypes.string.isRequired,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    handler: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      index: props.index
    };
  }

  static getDerivedStateFromProps(props, state) {
    return {
      index: props.index
    };
  }

  @Bind()
  clickHandler(e) {
    this.props.handler(this.state.index);
  }

  render() {
    const { photo } = this.props;
    return (
      <div className={styles.EmployeeTile} onClick={this.clickHandler}>
        <img
          className={styles.Avatar}
          src={OptimizeImagesService.adjustImageSize(photo)}
          alt="Employee"
        />
      </div>
    );
  }
}

export default EmployeeTile;



// WEBPACK FOOTER //
// ./src/views/TeamOfExperts/components/EmployeeTile/EmployeeTile.js